<template>
  <div>
    <FacebookReauthModal v-if="influencerNeedsEmailPermission" permission="email address" @start-fb-reauth="handleFbReauthRequest" />
    <v-btn :loading="loading" :disabled="!facebookInitialized || disabled" large color="accent" block rounded @click="doFbLogin(false)">
      CONTINUE WITH FACEBOOK
    </v-btn>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'

import { ApiService, FacebookService } from '@/services'

import FacebookReauthModal from '@/components/FacebookReauthModal.vue'

export default Vue.extend({
  name: 'FacebookLoginButton',

  components: {
    FacebookReauthModal,
  },
  props: {
    onboardSource: {
      type: String,
      default: 'Unknown',
    },
    disabled: Boolean,
  },

  data: () => ({
    loading: false,
    facebookInitialized: false,
    influencerNeedsEmailPermission: false,
  }),
  mounted: function () {
    FacebookService.init().then((response) => {
      this.facebookInitialized = true
    })
  },

  methods: {
    ...mapActions('auth', ['login']),
    handleFbReauthRequest(value) {
      this.influencerNeedsEmailPermission = false

      if (!value) {
        this.$emit('login-request-failed')
        return
      }

      this.doFbLogin(true)
    },
    doFbLogin: async function (rerequest = false) {
      this.loading = true
      this.$emit('login-facebook-requested-started')

      const fbLoginResponse = await FacebookService.login('email', rerequest)
      if (!fbLoginResponse.authResponse) {
        this.loading = false
        this.$emit('login-request-failed')
        return
      }

      if (!fbLoginResponse.authResponse.grantedScopes.includes('email')) {
        this.loading = false
        this.influencerNeedsEmailPermission = true
        return
      }

      ApiService.post(`auth/facebook`, {
        accessToken: fbLoginResponse.authResponse.accessToken,
        onboard_source: this.onboardSource,
      }).then((response) => {
        this.login({ token: response.data.token })
      })
    },
  },
})
</script>
